<notification-container [style]="{marginTop: '-6px'}" key="severity"></notification-container>

<ng-template let-messageContainer #messageTemplate>
  <div class="pt-notification-item-content">
    <div class="pt-notification-item-text-content" [ngClass]="{'headerClass': getDivHeight() < 44}">
      <header [ngSwitch]="notificationMessageService.iconType">
        <dls-icon *ngSwitchCase="NotificationMessageTypes.INFO" class="icon-dls-info pt-icon iconAllign"></dls-icon>
        <dls-icon *ngSwitchCase="NotificationMessageTypes.SUCCESS" class="icon-dls-file-upload-success pt-icon iconAllign"></dls-icon>
        <dls-icon *ngSwitchCase="NotificationMessageTypes.WARN" class="icon-dls-warning pt-icon iconAllign"></dls-icon>
        <dls-icon *ngSwitchCase="NotificationMessageTypes.ERROR" class="icon-dls-file-upload-error pt-icon iconAllign"></dls-icon>

        <div class="pt-header-text" id="{{notificationMessageService.iconType}}-message">
          <h1 class="textCss" id="messageTitle" [innerHTML]="messageContainer.title"></h1>
        </div>

        <button class="pt-clear-button pt-quiet pt-bubble-close-button pt-button buttonAllign" (click)="closeNotification(messageContainer)">
          <dls-layout-container class="pt-layout-container">
            <dls-icon class="icon-dls-cross pt-icon crossButtonColor"></dls-icon>
          </dls-layout-container>
        </button>
      </header>

      <div class="pt-messsage-body">
        <ng-container *ngIf="messageContainer.body">
            <p class="textCss body" id="messageBody" [innerHTML]="messageContainer.body"></p>
        </ng-container>
      </div>
    </div>

    <footer *ngFor="let button of messageContainer.buttons" class="ng-star-inserted">
      <button dlsbutton class="pt-quiet pt-button ng-star-inserted" (click)="doButtonAction(button.action, messageContainer)">
        <dls-layout-container class="pt-layout-container" style="font-size: 16px">{{button.label}}</dls-layout-container>
      </button>
    </footer>
  </div>
</ng-template>
